import Certificate from "./certificate.webp";
import Plutonn from "./plutonn.webp";
import Editor from "./editor.webp";
import Resume from "./resume.webp";
import Reward from "./reward.webp";
import Badge from "./badge.png";
const Image = {
  Certificate,
  Plutonn,
  Editor,
  Resume,
  Reward,
  Badge,
};
export default Image;
